"use client";
import { Image } from "@/template/components/index.ts";
import * as S from "./styles.ts";
import { CSSProperties } from "react";
import Swiggly from "@/lib/images/Swigg.svg";

const ArchStandaloneSectionComponent = ({
  color = "grey",
  background,
  withPadding,
  flip,
  style,
  vector,
}: {
  color?: "white" | "grey" | "dark";
  background?: "dark" | "grey";
  withPadding?: boolean;
  flip?: boolean;
  style?: CSSProperties;
  vector?: boolean;
}) => {
  return (
    <S.ArchStandaloneSectionWrapper
      $background={background}
      $withPadding={withPadding}
      style={
        flip
          ? {
              transform: "rotate(180deg)",
              ...style,
            }
          : style
      }
    >
      {vector && (
        <S.VectorWrapper>
          <Image
            src={Swiggly.src}
            alt="Vector"
          />
        </S.VectorWrapper>
      )}
      <S.Arch $color={color} />
    </S.ArchStandaloneSectionWrapper>
  );
};

export default ArchStandaloneSectionComponent;

export const options = [
  {
    description: "",
    displayName: "ArchStandaloneSectionComponent",
    methods: [],
    props: {
      color: {
        required: true,
        flowType: {
          name: "union",
          raw: '"white" | "grey"',
          elements: [
            { name: "literal", value: '"white"' },
            { name: "literal", value: '"grey"' },
          ],
        },
        description: "",
      },
      background: {
        required: false,
        flowType: {
          name: "union",
          raw: '"dark" | "grey"',
          elements: [
            { name: "literal", value: '"dark"' },
            { name: "literal", value: '"grey"' },
          ],
        },
        description: "",
      },
      withPadding: {
        required: false,
        flowType: { name: "boolean" },
        description: "",
      },
    },
  },
];
